export default __webpack_public_path__ + "videos/particle-glow-trail-silver-360w.0860b8716130c1378dd06f38f9e62a2c.webm";